import React, { useMemo } from "react";
import PropTypes from "prop-types";
import withErrorGuard from "../../HOC/withErrorGuard";
import Pulsar from "../Pulsar";
import getTracks from "./getDellyCnvBrowserTracks";
import {
  COVERAGE_CL_DELLY,
  TRANSCRIPT_CL,
  PATHOGENICITY_CL_DELLY,
} from "../Pulsar/constants/options";
import WebglErrorView from "../../HOC/withErrorGuard/WebglErrorView";

function DellyCnvBrowser({
  start,
  end,
  visStart,
  visEnd,
  analysisId,
  sampleId,
  originAnalId,
  genome,
}) {
  const tracks = useMemo(() => getTracks(sampleId), [sampleId]);

  return (
    <Pulsar
      title="CNV Browser"
      key="cnv-browser"
      trackConfs={tracks}
      visStart={visStart}
      visEnd={visEnd}
      start={start}
      end={end}
      allowedColorScales={[
        TRANSCRIPT_CL,
        PATHOGENICITY_CL_DELLY,
        COVERAGE_CL_DELLY,
      ]}
      state={{
        sampleId,
        analysisId,
        originAnalId,
        genome,
      }}
    />
  );
}

DellyCnvBrowser.propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  visStart: PropTypes.number.isRequired,
  visEnd: PropTypes.number.isRequired,
  analysisId: PropTypes.string.isRequired,
  sampleId: PropTypes.string.isRequired,
  originAnalId: PropTypes.string.isRequired,
  genome: PropTypes.string.isRequired,
};

DellyCnvBrowser.defaultProps = {};

export default withErrorGuard(
  DellyCnvBrowser,
  "DellyCnvBrowser",
  "Delly Cnv Browser",
  WebglErrorView
);
